import { WithdrawalsReceiveSetOrderStatusReducer } from './types';

export const withdrawalsReceiveSetOrderStatusReducer: WithdrawalsReceiveSetOrderStatusReducer =
  (state, action) => {
    const { id, status } = action.payload;
    const { withdrawalsList } = state;

    const withdrawalsToProcess = withdrawalsList.items?.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          status,
        };
      }

      return item;
    });

    return {
      ...state,
      withdrawalsList: {
        ...state.withdrawalsList,
        items: withdrawalsToProcess,
      },
    };
  };
